import { NameInputValues } from './NameInput.types';

export const NAME_FIELDS: (keyof NameInputValues)[] = [
  'firstName',
  'middleName',
  'lastName',
];
